import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.f12_1 = this;
        this.g12_1 = this;
        this.h12_1 = false;
      }
      i12(node, permissionsBitmask) {
        var prev = this.g12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.i1m_1 & permissionsBitmask) === 0 && prev.i12(node, permissionsBitmask));
        } else {
          node.f12_1 = this;
          node.g12_1 = prev;
          prev.f12_1 = node;
          this.g12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      x14(forbiddenElementsBit) {
        this.i12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      j12() {
        if (this.h12_1)
          return false;
        var prev = this.g12_1;
        var next = this.f12_1;
        prev.f12_1 = next;
        next.g12_1 = prev;
        this.h12_1 = true;
        return true;
      }
      k12(node) {
        if (!(this.f12_1 === this))
          return false;
        this.i12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.i1m_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
